<template>
  <div class="Headline">
    <div class="Wrapper">
      <input v-model="mTitle" class="Title" />
      <label class="Label">H1</label>
    </div>
    <div class="Wrapper">
      <input v-model="mDescription" class="Description" />
      <label class="Label">meta</label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Headline',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    mTitle: {
      get() {
        return this.title;
      },
      set(value) {
        this.$emit('updateTitle', value);
      },
    },
    mDescription: {
      get() {
        return this.description;
      },
      set(value) {
        this.$emit('updateDescription', value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.Headline {
  color: color(white);
  margin-top: 40px;
  margin-bottom: 0px;
  margin-bottom: 15px;

  .Wrapper {
    position: relative;
    margin-bottom: 5px;
    padding-left: 0;
    padding-right: 0;
  }

  .Title {
    font-size: 1.75rem;
    margin: 0;
    line-height: 1.125;
    outline: none;
    margin-top: 0;
    background-color: transparent;
    border: none;
    color: color(white);
    font-family: font(regular);
    font-weight: bold;
  }

  .Description {
    outline: none;
    font-size: 0.85rem;
    margin-top: 0px;
    opacity: 0.75;
    position: relative;
  }

  .Label {
    position: absolute;
    left: 0;
    transform: translateX(calc(-100% - 15px));
    bottom: 0;
    font-size: 0.85rem;
    color: rgba(color(white), 0.25);
    user-select: none;
  }

  @media (min-width: breakpoint(desktop-small)) {
    .Title {
      font-size: 2rem;
    }

    .Description {
      font-size: 1rem;
    }
  }

  @media (min-width: breakpoint(desktop)) {
    .Title {
      font-size: 2rem;
    }

    .Description {
      font-size: 1rem;
    }
  }
}
</style>
